import routes_settings from './routes_settings'
import routes_customers from './routes_customers'
import routes_points from './routes_points'
import routes_catalogue from './routes_catalogue'

// lazy component loading
const StoresList = () => import(/* webpackChunkName: "loyaltyvenue" */ './StoresList.vue');
const Store = () => import(/* webpackChunkName: "loyaltyvenue" */ './Store.vue');

const Dashboard = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/Dashboard.vue');
const Reports = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/Reports.vue');

import tutorialsteps, {feature_tags} from './tutorial';
import {routerTutorialGuard} from '@/providers/tutorial'
import context from '@/providers/context'

const routes_reports = [
  {
    path: 'reports',
    name: 'loyaltyvenue.store.reports',
    component: Reports,
    meta: {
      icon: 'bargraph',
      trans: 'loyaltyvenue:general.titles.reports',
    },
  },
];

const routes_dashboard = [
  {
    name: 'loyaltyvenue.store.dashboard',
    path: 'dashboard',
    component: Dashboard,
    meta: {
      trans: 'loyaltyvenue:general.titles.dashboard',
      icon: 'dashboard',
    },
  },
];

//ROUTES

export const routes = [
{
  path: 'loyaltyvenue',
  redirect: {
    name: 'loyaltyvenue.list'
  },
  name: 'loyaltyvenue',
  //empty component just for base
  component: {
    template: '<router-view/>'
  },
  meta: {
    trans: 'loyaltyvenue:title',
    root: true,
  },
  children: [
    {
      path: 'storeslist',
      name: 'loyaltyvenue.list',
      component: StoresList,
      meta: {
        trans: 'Homepage',
        icon: 'loyaltyvenue',
      },
    },
    {
      path: ' ',
      redirect: {
        name: 'loyaltyvenue.list'
      },
      name: '',
      meta: {
        trans: ' ',
        icon: '',
      },
    },
    // {
    //   path: 'loyaltyvenue',
    //   name: 'loyaltyvenue.root',
    //   redirect: {name: 'loyaltyvenue'},
    //   meta: {
    //     title: false,
    //     root: true,
    //   },
    // },
    // {
    //   path: 'loyaltyvenue/list',
    //   name: 'loyaltyvenue',
    //   component: StoresList,
    //   meta: {
    //     trans: 'loyaltyvenue:title',
    //     icon: 'loyaltyvenue',
    //     up: 'loyaltyvenue.root',
    //     //root: true,
    //   },
    // },
    {
      path: 'loyaltyvenue/:store_id',
      name: 'loyaltyvenue.store',
      redirect: {name: 'loyaltyvenue.store.dashboard'},
      component: Store,
      props: true,
      meta: {
        trans: 'loyaltyvenue:title',
        root: true,
        up: 'loyaltyvenue.list',
      },
      children: [].concat(
        routes_dashboard,
        routes_settings,
        routes_reports,
        routes_customers,
        routes_points,
        routes_catalogue,
      )
    },
  ],
},
];

// TRANSLATIONS
import en from './i18n/en'
import it from './i18n/it'
import sl from './i18n/sl'
import i18n from '@/providers/i18n'

for (let [lang, bundle] of Object.entries({en, it, sl})) {
  i18n.i18next.addResourceBundle(lang, 'loyaltyvenue', bundle);
}

export function guard(router) {
  router.afterEach((to, from) => {
    if (to.name && to.name.split('.')[0] === 'loyaltyvenue') {
      import(/* webpackChunkName: "loyaltyvenue" */ './scss/style.scss');
    }
  })
  routerTutorialGuard(router, 'loyaltyvenue', 'admin-loyaltyvenue-tutorial', tutorialsteps);
  routerTutorialGuard(router, 'loyaltyvenue', 'admin-loyaltyvenue-feature-tags', feature_tags,
    () =>
    context.getters.async('apptoken')
      .then(token => {
        if (token.created_at > '2018-06-25') {
          return false;
        }
        return true;
      })
  );
}


// WEBPACK FOOTER //
// ./src/apps/loyaltyvenue/index.js